import {
    getExperiment,
    initializeSdk,
    logEvent,
    updateUser,
} from '@eventbrite/statsig';
import { Dispatch } from 'redux';
import {
    STATSIG_CHECKOUT_CLIENT_KEY,
    STATSIG_INTERSTITIAL_LOGIN_PARAM,
    STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY,
} from '../constants/statsig';
import { isStatsigFreeTrialEnabledForInterstitialLogin } from '../selectors/statsig';
import {
    getLoginFromCheckoutPage,
    getUserId,
    isUserLoggedIn,
} from '../selectors/user';
import { CheckoutState } from '../state';
import { AppNamespace } from '../state/app';
import { Experiment } from '../state/statsig';
import { getUserTrackingIDs } from '../utils/app';

// This sample rate was extracted from https://docs.google.com/spreadsheets/d/1-KuMCi_FkXYWWnPk5q7_ouTTuD0klI-dG7HXGOZ_rUc/edit?usp=sharing.
const SAMPLE_RATE = 2.5;

export const initializeStatsigSdk = async (app: AppNamespace) => {
    await initializeSdk({
        clientKey: STATSIG_CHECKOUT_CLIENT_KEY,
        sampleRate: SAMPLE_RATE,
        user: { customIDs: getUserTrackingIDs(app) },
    });
};

export const updateExperimentUser =
    () => async (_: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        await updateUser({ user: { userID: getUserId(getState()) } });
    };

export const logLoginInterstitialEvent =
    (eventName: string) =>
    (_: Dispatch<CheckoutState>, getState: () => CheckoutState) =>
        logEvent(eventName, null, {
            isInterstitialStep: `${!getLoginFromCheckoutPage(getState())}`,
        });

export const isLoginInterstitialEnabled =
    () => async (_: Dispatch<CheckoutState>, getState: () => CheckoutState) => {
        const state = getState();
        if (
            isUserLoggedIn(state) ||
            !isStatsigFreeTrialEnabledForInterstitialLogin(state)
        ) {
            return false;
        }

        return getExperiment(
            STATSIG_LOGIN_INTERSTITIAL_EXPERIMENT_KEY,
            STATSIG_INTERSTITIAL_LOGIN_PARAM,
            false,
        );
    };

export enum StatsigActionType {
    saveExperimentData = 'saveExperimentData',
}

export interface SaveExperimentDataAction {
    type: StatsigActionType.saveExperimentData;
    payload: Experiment;
}

export const saveExperimentDataAction = (
    experiment: Experiment,
): SaveExperimentDataAction => ({
    type: StatsigActionType.saveExperimentData,
    payload: experiment,
});

export type StatsigAction = SaveExperimentDataAction;
